import { Enumify } from "enumify-ts";
import { ADD_PAYMENT_METHOD_QUERY_PARAM } from "../routes/billing/tenant/StoredPaymentMethodsTable";
class SetupStepType extends Enumify() {
    description;
    path;
    static DRIVERS = new SetupStepType("Set up drivers", "/#/app/drivers/edit/new");
    static VEHICLES = new SetupStepType("Set up vehicles", "#/app/vehicles/edit/new");
    static PAYMENT_METHOD = new SetupStepType("Add payment method", `/#/app/billing/tenant?${ADD_PAYMENT_METHOD_QUERY_PARAM}=1`);
    static _ = SetupStepType._closeEnum();
    constructor(description, path) {
        super();
        this.description = description;
        this.path = path;
    }
}
export default SetupStepType;
